module.exports = __webpack_public_path__ + "static/media/qrcode-appstore.60d6caff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gJunior/qrcode-appstore.svg
// module id = 331
// module chunks = 21